<template>
    <div class="server-page">
        <el-tabs v-model="activeTab" class="server-tabs">
            <!-- ==================== 服务器列表 ==================== -->
            <el-tab-pane label="服务器列表" name="machine">
                <div class="sm-toolbar">
                    <div class="sm-toolbar__info">
                        <span class="sm-toolbar__icon">
                            <el-icon>
                                <Monitor />
                            </el-icon>
                        </span>
                        <span class="sm-toolbar__meta">
                            <span class="sm-toolbar__title">服务器列表</span>
                            <span class="sm-toolbar__subtitle">维护服务器连接信息，并为每台服务器配置可执行的指令</span>
                        </span>
                    </div>
                    <div class="sm-toolbar__actions">
                        <el-button class="sm-btn sm-btn--ghost" :loading="machineLoading" @click="loadMachine">
                            <el-icon v-if="!machineLoading" class="sm-btn__icon">
                                <Refresh />
                            </el-icon>
                            刷新
                        </el-button>
                        <el-button class="sm-btn" type="primary" @click="openCreateMachine">
                            <el-icon class="sm-btn__icon">
                                <Plus />
                            </el-icon>
                            创建服务器
                        </el-button>
                    </div>
                </div>

                <section class="sm-panel" v-loading="machineLoading">
                    <el-empty v-if="currentMachineList.length === 0 && !machineLoading"
                        description="还没有服务器，点击右上角「创建服务器」开始" />
                    <template v-else>
                        <section class="machine-group" v-for="group in machineGroupList" :key="group.key">
                            <div class="machine-group__head" v-if="showGroupHeader">
                                <span class="machine-group__name">{{ group.name }}</span>
                                <span class="count-pill">{{ group.list.length }} 台</span>
                            </div>
                            <el-collapse accordion class="machine-collapse" @change="showCmdList">
                                <el-collapse-item v-for="item in group.list" :key="item.id.toString()" :name="item.id">
                                    <template #title>
                                        <div class="machine-head">
                                            <div class="machine-head__main">
                                                <span class="machine-name">{{ item.name }}</span>
                                                <span class="machine-address">（{{ item.address }}）</span>
                                                <el-tag v-if="currentCmdMap[item.id]" class="machine-cmd-count" size="small"
                                                    type="info" effect="plain" round>{{ currentCmdMap[item.id].length
                                                    }}条指令</el-tag>
                                                <el-tag v-if="item.prodLock" class="machine-lock" type="danger" size="small"
                                                    effect="plain">生产防护</el-tag>
                                            </div>
                                            <!-- 阻止冒泡，避免点击操作时触发展开/收起 -->
                                            <div class="machine-head__ops" @click.stop>
                                                <el-link class="sm-op" type="primary" @click="openEditMachine(item.id)">编辑</el-link>
                                                <el-popconfirm width="240" title="删除操作不可撤回，确定删除该服务器吗？"
                                                    confirm-button-text="确定删除" cancel-button-text="取消"
                                                    @confirm="deleteMachine(item.id)">
                                                    <template #reference>
                                                        <el-link class="sm-op" type="danger">删除</el-link>
                                                    </template>
                                                </el-popconfirm>
                                            </div>
                                        </div>
                                    </template>

                                    <div>
                                        <p class="machine-desc">{{ item.description || '暂无描述' }}</p>
                                        <div class="machine-teams">
                                            <span class="team-label">通用执行权限团队：</span>
                                            <el-tag v-for="t in resolveTeams(item.teamIdList)" :key="t.id" size="small"
                                                type="info" effect="plain" class="team-tag">{{ t.name }}</el-tag>
                                            <span v-if="resolveTeams(item.teamIdList).length === 0" class="team-empty">无</span>
                                            <span class="team-label" style="margin-left:12px;">控制台执行权限团队：</span>
                                            <el-tag v-for="t in resolveTeams(item.consoleTeamIdList)" :key="t.id" size="small"
                                                type="warning" effect="plain" class="team-tag">{{ t.name }}</el-tag>
                                            <span v-if="resolveTeams(item.consoleTeamIdList).length === 0"
                                                class="team-empty">无</span>
                                        </div>

                                        <div class="cmd-block">
                                            <div class="cmd-block__head">
                                                <span class="cmd-block__title">指令列表</span>
                                                <el-button class="sm-btn sm-btn--sm" type="primary" plain
                                                    @click="openCreateCmd(item.id)">
                                                    <el-icon class="sm-btn__icon">
                                                        <Plus />
                                                    </el-icon>
                                                    创建指令
                                                </el-button>
                                            </div>
                                            <el-table v-loading="cmdLoadingMap[item.id]" class="sm-table"
                                                :data="currentCmdMap[item.id] || []" stripe style="width: 100%">
                                                <el-table-column prop="name" label="名称" min-width="160"
                                                    show-overflow-tooltip></el-table-column>
                                                <el-table-column label="类型" width="90" align="center">
                                                    <template #default="scope">
                                                        <el-tag size="small" type="info" effect="plain">{{ scope.row.type || '—'
                                                            }}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="指令" min-width="220" show-overflow-tooltip>
                                                    <template #default="scope">
                                                        <span class="cmd-content">{{ scope.row.contentTa || '—' }}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="操作" width="120">
                                                    <template #default="scope">
                                                        <!-- <el-link class="sm-op" type="success" @click="runCmd(scope.row)">执行</el-link> -->
                                                        <el-link class="sm-op" type="warning" @click="openEditCmd(scope.row)">编辑</el-link>
                                                        <el-popconfirm width="240" title="删除操作不可撤回，确定删除该指令吗？"
                                                            confirm-button-text="确定删除" cancel-button-text="取消"
                                                            @confirm="deleteCmd(scope.row)">
                                                            <template #reference>
                                                                <el-link class="sm-op" type="danger">删除</el-link>
                                                            </template>
                                                        </el-popconfirm>
                                                    </template>
                                                </el-table-column>
                                                <template #empty>
                                                    <el-empty description="该服务器还没有指令" :image-size="70" />
                                                </template>
                                            </el-table>
                                        </div>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </section>
                    </template>
                </section>
            </el-tab-pane>

            <!-- ==================== 执行日志 ==================== -->
            <el-tab-pane label="执行日志" name="log">
                <div class="sm-toolbar">
                    <div class="sm-toolbar__info">
                        <span class="sm-toolbar__icon">
                            <el-icon>
                                <Tickets />
                            </el-icon>
                        </span>
                        <span class="sm-toolbar__meta">
                            <span class="sm-toolbar__title">执行日志</span>
                            <span class="sm-toolbar__subtitle">查看指令的历史执行记录与输出详情</span>
                        </span>
                    </div>
                </div>

                <section class="sm-panel">
                    <div class="log-search">
                        <div class="log-search__fields">
                            <div class="log-field">
                                <span class="log-field__label">执行服务器</span>
                                <el-input v-model="searchDataParams.planName" placeholder="请输入服务器名称" clearable
                                    @keydown="searchDataEnter" />
                            </div>
                            <div class="log-field">
                                <span class="log-field__label">执行命令</span>
                                <el-input v-model="searchDataParams.dataSource" placeholder="请输入命令名称" clearable
                                    @keydown="searchDataEnter" />
                            </div>
                            <div class="log-field">
                                <span class="log-field__label">执行人</span>
                                <el-input v-model="searchDataParams.ip" placeholder="请输入执行人姓名" clearable
                                    @keydown="searchDataEnter" />
                            </div>
                        </div>
                        <div class="log-search__actions">
                            <el-button class="sm-btn sm-btn--ghost" @click="resetSearch">重置</el-button>
                            <el-button class="sm-btn" type="primary" @click="searchData">
                                <el-icon class="sm-btn__icon">
                                    <Search />
                                </el-icon>
                                搜索
                            </el-button>
                        </div>
                    </div>

                    <el-table v-loading="exeLogLoading" class="sm-table" :data="exeLogList" stripe style="width: 100%">
                        <el-table-column label="执行时间" width="190">
                            <template #default="scope">
                                <div class="exe-log-time">
                                    <span class="exe-log-time__begin">{{ scope.row.beginTime }}</span>
                                    <span class="exe-log-time__end">{{ scope.row.endTime }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="执行服务器" min-width="200">
                            <template #default="scope">
                                <span v-if="scope.row.machine">
                                    {{ scope.row.machine.name }}
                                    <span class="exe-log-address">[{{ scope.row.machine.address }}]</span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="执行命令" min-width="180" show-overflow-tooltip>
                            <template #default="scope">
                                {{ scope.row.cmd ? scope.row.cmd.name : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="执行人" width="120">
                            <template #default="scope">
                                {{ scope.row.runUser ? scope.row.runUser.realName : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template #default="scope">
                                <el-link class="sm-op" type="primary" @click="exeLogDetail(scope.row)">详情</el-link>
                            </template>
                        </el-table-column>
                        <template #empty>
                            <el-empty description="暂无执行日志" :image-size="80" />
                        </template>
                    </el-table>
                    <!-- 分页：胶囊样式，滚到列表下方时吸附在内容区底部，无需滚到底部才能翻页 -->
                    <el-affix position="bottom" :offset="24">
                        <div class="exe-log-pagination">
                            <span class="exe-log-pagination__total">共 {{ exeLogPage.total }} 条</span>
                            <el-pagination background :pager-count="5" layout="prev, pager, next"
                                :total="exeLogPage.total" :current-page="exeLogPage.current"
                                :page-size="exeLogPage.size" @current-change="handleExeLogPageChange" />
                        </div>
                    </el-affix>
                </section>
            </el-tab-pane>
        </el-tabs>

        <!-- 服务器表单 -->
        <el-dialog class="sm-dialog" :title="machineForm.mode == 'create' ? '创建服务链接' : '编辑服务链接'"
            v-model="machineForm.dialog" width="min(560px, 94vw)" top="7.5vh" :close-on-click-modal="false">
            <el-form :model="machineForm.prop" label-width="120px">
                <el-form-item label="名称">
                    <el-input v-model="machineForm.prop.name" placeholder="请输入服务器名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="分组">
                    <el-select v-model="machineForm.prop.groupName" style="width: 100%" filterable allow-create
                        default-first-option clearable placeholder="可选择已有分组，或直接输入新分组">
                        <el-option v-for="g in groupOptions" :key="g" :label="g" :value="g" />
                    </el-select>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input type="textarea" :rows="2" maxlength="200" placeholder="简要说明该服务器的用途"
                        v-model="machineForm.prop.description"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="machineForm.prop.type" placeholder="请选择" clearable style="width: 100%">
                        <el-option v-for="item in machineTypeSelect" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="machineForm.prop.address" placeholder="例如 192.168.1.10" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="端口">
                    <el-input v-model="machineForm.prop.port" placeholder="例如 22" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="账号">
                    <!-- 服务器账号与站点账号无关，禁用浏览器自动填充（off 会被浏览器忽略） -->
                    <el-input v-model="machineForm.prop.username" name="serverAccount" placeholder="登录账号"
                        autocomplete="new-password"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model="machineForm.prop.password" name="serverPassword" type="password"
                        placeholder="登录密码" autocomplete="new-password" show-password></el-input>
                </el-form-item>
                <el-form-item label="生产防护锁">
                    <div class="sm-switch-row">
                        <el-switch v-model="machineForm.prop.prodLock" />
                        <span class="sm-tips">开启后将启用生产环境防护</span>
                    </div>
                </el-form-item>
                <el-form-item label="通用执行权限团队">
                    <el-select v-model="machineForm.prop.teamIdList" multiple placeholder="可选择已加入的团队"
                        style="width: 100%">
                        <el-option v-for="item in team.myJoin" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <p class="sm-tips">团队成员可查看该服务器并执行其中的指令；不选择团队时，该服务器仅自己可见</p>
                </el-form-item>
                <el-form-item label="控制台执行权限团队">
                    <el-select v-model="machineForm.prop.consoleTeamIdList" multiple placeholder="可选择已加入的团队"
                        style="width: 100%">
                        <el-option v-for="item in team.myJoin" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <p class="sm-tips">团队成员可使用该服务器的网页控制台；不选择团队时，仅自己可使用控制台</p>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="sm-dialog__foot">
                    <el-button @click="machineForm.dialog = false">取 消</el-button>
                    <el-button type="primary" :loading="savingMachine" @click="saveMachine">保 存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 指令表单 -->
        <el-dialog class="sm-dialog" :title="cmdForm.mode == 'create' ? '创建服务指令' : '编辑服务指令'"
            v-model="cmdForm.dialog" width="min(900px, 94vw)" top="7.5vh" :close-on-click-modal="false">
            <el-form :model="cmdForm.prop" label-width="104px">
                <el-form-item label="名称">
                    <el-input v-model="cmdForm.prop.name" placeholder="请输入指令名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input type="textarea" :rows="2" maxlength="200" placeholder="简要说明该指令的用途"
                        v-model="cmdForm.prop.description"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="cmdForm.prop.type" placeholder="请选择" clearable style="width: 100%">
                        <el-option v-for="item in cmdTypeSelect" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="指令a">
                    <el-input ref="contentTaRef" type="textarea" :rows="2" placeholder="请输入内容" class="sm-mono"
                        v-model="cmdForm.prop.contentTa" @focus="markActiveField('contentTa')"></el-input>
                </el-form-item>
                <el-form-item label="指令b">
                    <el-input ref="contentTbRef" type="textarea" :rows="2" placeholder="请输入内容" class="sm-mono"
                        v-model="cmdForm.prop.contentTb" @focus="markActiveField('contentTb')"></el-input>
                </el-form-item>
                <el-form-item label="指令c">
                    <el-input ref="contentTcRef" type="textarea" :rows="2" placeholder="请输入内容" class="sm-mono"
                        v-model="cmdForm.prop.contentTc" @focus="markActiveField('contentTc')"></el-input>
                </el-form-item>

                <!-- 占位符面板：执行时由后端替换，前端只负责插入 token -->
                <div class="ph-toggle" v-if="!placeholder.show">
                    <el-link type="primary" @click="placeholder.show = true">显示占位符</el-link>
                </div>
                <div class="ph-panel" v-else>
                    <div class="ph-panel__head">
                        <span class="ph-panel__title">占位符（点击插入到光标处）</span>
                        <el-link type="primary" @click="placeholder.show = false">收起</el-link>
                    </div>
                    <el-input v-model="placeholder.keyword" size="small" clearable
                        placeholder="搜索占位符，例如 uuid、时间、machine"></el-input>
                    <div class="ph-panel__group" v-for="g in placeholderGroups" :key="g.name">
                        <span class="ph-panel__group-name">{{ g.name }}</span>
                        <div class="ph-panel__chips">
                            <el-tooltip v-for="item in g.list" :key="item.key + item.token"
                                :content="item.description + '，示例：' + item.example" placement="top">
                                <el-tag class="ph-chip" size="small" @click="insertPlaceholder(item)">
                                    {{ item.token }}
                                </el-tag>
                            </el-tooltip>
                        </div>
                    </div>
                    <p class="ph-panel__tip">执行时由后端替换；同一指令内相同占位符取值一致。</p>
                </div>

                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="监控端口">
                            <el-input-number v-model="cmdForm.prop.port" :min="0" :max="65535"
                                controls-position="right" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="执行间隔">
                            <el-input-number v-model="cmdForm.prop.interval" :min="0" :max="3600"
                                controls-position="right" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div class="sm-dialog__foot">
                    <el-button @click="cmdForm.dialog = false">取 消</el-button>
                    <el-button type="primary" :loading="savingCmd" @click="saveCmd">保 存</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 日志文件详情 -->
        <el-dialog class="sm-dialog sm-dialog--full" v-model="exeLogDialog.dialog" title="日志文件详情" width="90%" center
            fullscreen>
            <div class="log-detail" v-loading="logDetailLoading">
                <div class="log-detail__block">
                    <div class="log-detail__title">基本信息</div>
                    <el-descriptions :column="2" border size="small">
                        <el-descriptions-item label="执行时间" :span="2">
                            <span>{{ exeLogDialog.current.beginTime }}</span>
                            <span class="log-time-sep">→</span>
                            <span class="log-time-end">{{ exeLogDialog.current.endTime }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="执行服务器">
                            {{ exeLogDialog.current.machine ? exeLogDialog.current.machine.name + ' [' +
                                exeLogDialog.current.machine.address + ']' : '' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="执行命令">
                            {{ exeLogDialog.current.cmd ? exeLogDialog.current.cmd.name : '' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="脚本a" :span="2">
                            <span class="exe-log-script">{{ exeLogDialog.current.contentTa }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="实际执行" :span="2">
                            <span class="exe-log-script">{{ exeLogDialog.current.resolvedContentTa || '（无占位符或历史数据）' }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="脚本a结果" :span="2">
                            <span class="exe-log-script">{{ exeLogDialog.current.resultTa }}</span>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>

                <div class="log-detail__block">
                    <div class="log-detail__title">执行输出</div>
                    <div class="log-detail__editor">
                        <v-md-editor v-model="exeLogDialog.current.fileDetail" mode="preview"
                            @copy-code-success="handleCopyCodeSuccess" />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="sm-dialog__foot sm-dialog__foot--center">
                    <el-button type="primary" @click="exeLogDialog.dialog = false">关 闭</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';

// 未填写分组时的兜底分组标识
const UNGROUPED_KEY = '__ungrouped__';

export default {
    data() {
        return {
            activeTab: 'machine',
            machineForm: {
                mode: 'create',
                dialog: false,
                prop: {
                    name: '',
                    groupName: '',
                    description: '',
                    type: '',
                    address: '',
                    port: 0,
                    username: '',
                    password: '',
                    prodLock: false,
                    teamIdList: [],
                    consoleTeamIdList: []
                }
            },
            cmdForm: {
                mode: 'create',
                dialog: false,
                prop: {
                    machineId: '',
                    name: '',
                    description: '',
                    type: '',
                    contentTa: '',
                    contentTb: '',
                    contentTc: '',
                    port: 0
                }
            },
            currentMachineId: '',
            currentMachineList: [],
            // 占位符面板：清单来自后端，前端只负责展示与插入
            placeholder: {
                show: true,
                loaded: false,
                loading: false,
                keyword: '',
                activeField: 'contentTa',
                list: []
            },
            // 按服务器 id 分别缓存指令列表与加载状态，避免多个折叠面板共用一个列表导致内容串台
            currentCmdMap: {},
            cmdLoadingMap: {},
            exeLogDialog: {
                dialog: false,
                current: {
                    fileDetail: '',
                    machine: null,
                    cmd: null,
                    beginTime: '',
                    endTime: '',
                    contentTa: '',
                    resolvedContentTa: '',
                    resultTa: ''
                }
            },
            exeLogList: [],
            exeLogPage: {
                current: 1,
                size: 20,
                total: 0
            },
            searchDataParams: {
                createTime: '',
                planName: '',
                dataSource: '',
                ip: '',
                mac: '',
                senderId: '',
                senderName: '',
                dataString: ''
            },
            machineTypeSelect: [
                {
                    value: 'ssh',
                    label: 'ssh'
                }
            ],
            cmdTypeSelect: [
                {
                    value: '通用',
                    label: 'normal'
                }
            ],
            team: {
                myJoin: []
            },
            machineLoading: false,
            exeLogLoading: false,
            logDetailLoading: false,
            savingMachine: false,
            savingCmd: false
        };
    },
    computed: {
        // 按分组字段聚合服务器；未填写的归到「未分组」并排在最后
        machineGroupList() {
            const groups = new Map();
            this.currentMachineList.forEach(machine => {
                const name = (machine.groupName || '').trim();
                const key = name || UNGROUPED_KEY;
                if (!groups.has(key)) {
                    groups.set(key, { key, name: name || '未分组', list: [] });
                }
                groups.get(key).list.push(machine);
            });

            const named = [];
            let ungrouped = null;
            groups.forEach(group => {
                if (group.key === UNGROUPED_KEY) {
                    ungrouped = group;
                } else {
                    named.push(group);
                }
            });
            named.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
            return ungrouped ? named.concat(ungrouped) : named;
        },
        // 只有存在已分组的数据时才展示分组标题，全部未分组时保持原来的平铺样式
        showGroupHeader() {
            return this.machineGroupList.some(group => group.key !== UNGROUPED_KEY);
        },
        // 已录入的分组（去重、排序），供表单下拉选择
        groupOptions() {
            const set = new Set();
            this.currentMachineList.forEach(machine => {
                const name = (machine.groupName || '').trim();
                if (name) set.add(name);
            });
            return Array.from(set).sort((a, b) => a.localeCompare(b, 'zh-CN'));
        },
        // 占位符按后端分组顺序聚合，并按关键字过滤
        placeholderGroups() {
            const kw = (this.placeholder.keyword || '').trim().toLowerCase();
            const filtered = this.placeholder.list.filter(item => {
                if (!kw) return true;
                return [item.key, item.description, item.example, item.token]
                    .join(' ').toLowerCase().includes(kw);
            });
            const groups = [];
            filtered.forEach(item => {
                let group = groups.find(g => g.name === item.group);
                if (!group) {
                    group = { name: item.group, list: [] };
                    groups.push(group);
                }
                group.list.push(item);
            });
            return groups;
        }
    },
    mounted() {
        this.loadMyJoinTeam();
        this.loadMachine();
        this.loadExeLogList();
    },
    methods: {
        searchDataEnter(e) {
            if (e.key === 'Enter') {
                this.searchData();
            }
        },
        searchData() {
            this.exeLogPage.current = 1;
            return this.loadExeLogList();
        },
        resetSearch() {
            this.searchDataParams.planName = '';
            this.searchDataParams.dataSource = '';
            this.searchDataParams.ip = '';
            return this.searchData();
        },
        handleExeLogPageChange(page) {
            this.exeLogPage.current = page;
            return this.loadExeLogList();
        },
        loadExeLogList() {
            this.exeLogLoading = true;
            return request({
                url: '/serverManExeLog/pageList',
                method: 'post',
                data: {
                    ...this.searchDataParams,
                    token: this.$store.state.user.token,
                    current: this.exeLogPage.current,
                    size: this.exeLogPage.size
                }
            }).then(res => {
                if (res.code == 0) {
                    this.exeLogList = res.data || [];
                    this.exeLogPage.total = res.total || 0;
                }
            }).finally(() => {
                this.exeLogLoading = false;
            });
        },
        showCmdList(machineId) {
            // 收起面板时不会带上机器 id，此时无需重新拉取指令
            if (!machineId) {
                return;
            }
            this.currentMachineId = machineId;
            // 每次展开都重新拉取，避免多端维护时展示的是旧数据（同时刷新标题上的条数）
            this.loadCmd(machineId);
        },
        openCreateMachine() {
            this.loadMyJoinTeam();

            // 清空表单数据
            this.machineForm.prop.name = '';
            this.machineForm.prop.groupName = '';
            this.machineForm.prop.description = '';
            this.machineForm.prop.type = '';
            this.machineForm.prop.address = '';
            this.machineForm.prop.port = '';
            this.machineForm.prop.username = '';
            this.machineForm.prop.password = '';
            this.machineForm.prop.prodLock = false;
            this.machineForm.prop.teamIdList = [];
            this.machineForm.prop.consoleTeamIdList = [];

            this.machineForm.mode = 'create';
            this.machineForm.dialog = true;
        },
        openEditMachine(machineId) {
            this.loadMyJoinTeam();

            return request({
                url: '/serverManMachine/get',
                method: 'post',
                data: { token: this.$store.state.user.token, id: machineId }
            }).then(res => {
                if (res.code == 0 && res.meta.serverManMachine) {
                    this.machineForm.prop = res.meta.serverManMachine;
                    // 老数据可能没有该字段，统一成字符串，避免输入框出现 null
                    this.machineForm.prop.groupName = this.machineForm.prop.groupName || '';
                    // 老数据可能没有控制台执行权限团队，统一成数组，避免多选框报错
                    this.machineForm.prop.consoleTeamIdList = this.machineForm.prop.consoleTeamIdList || [];
                    this.machineForm.mode = 'edit';
                    this.machineForm.dialog = true;
                }
            });
        },
        loadMachine() {
            this.machineLoading = true;
            return request({
                url: '/serverManMachine/list',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.currentMachineList = res.meta.serverManMachines;
                    // 预取各服务器的指令，供标题展示条数
                    this.loadMachineCmdCounts();
                }
            }).finally(() => {
                this.machineLoading = false;
            });
        },
        loadMachineCmdCounts() {
            const list = this.currentMachineList || [];
            return Promise.all(list.map(item => this.loadCmd(item.id)));
        },
        saveMachine() {
            const prop = this.machineForm.prop;
            const data = {
                name: prop.name,
                groupName: prop.groupName,
                description: prop.description,
                type: prop.type,
                address: prop.address,
                port: prop.port,
                username: prop.username,
                password: prop.password,
                prodLock: prop.prodLock,
                teamIdList: prop.teamIdList,
                consoleTeamIdList: prop.consoleTeamIdList
            };
            const isCreate = this.machineForm.mode == 'create';
            this.savingMachine = true;
            return request({
                url: isCreate ? '/serverManMachine/create' : '/serverManMachine/edit',
                method: 'post',
                data: isCreate ? data : Object.assign({ id: prop.id }, data)
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({ message: '保存成功', type: 'success', duration: 2 * 1000 });
                    this.machineForm.dialog = false;
                    this.loadMachine();
                }
            }).finally(() => {
                this.savingMachine = false;
            });
        },
        deleteMachine(machineId) {
            return request({
                url: '/serverManMachine/delete',
                method: 'post',
                data: { token: this.$store.state.user.token, id: machineId }
            }).then(res => {
                if (res.code == 0) {
                    this.loadMachine();
                }
            });
        },
        openCreateCmd(machineId) {
            this.ensurePlaceholders();
            this.placeholder.keyword = '';
            this.placeholder.activeField = 'contentTa';

            // 清空表单数据
            this.cmdForm.prop.machineId = machineId;
            this.cmdForm.prop.name = '';
            this.cmdForm.prop.description = '';
            this.cmdForm.prop.type = '';
            this.cmdForm.prop.contentTa = '';
            this.cmdForm.prop.contentTb = '';
            this.cmdForm.prop.contentTc = '';
            this.cmdForm.prop.port = 0;
            this.cmdForm.prop.interval = 0;

            this.cmdForm.mode = 'create';
            this.cmdForm.dialog = true;
        },
        openEditCmd(row) {
            this.ensurePlaceholders();
            this.placeholder.keyword = '';
            this.placeholder.activeField = 'contentTa';

            return request({
                url: '/serverManCmd/get',
                method: 'post',
                data: { token: this.$store.state.user.token, id: row.id }
            }).then(res => {
                if (res.code == 0 && res.meta.serverManCmd) {
                    this.cmdForm.prop = res.meta.serverManCmd;
                    this.cmdForm.mode = 'edit';
                    this.cmdForm.dialog = true;
                }
            });
        },
        // 占位符清单只加载一次，失败时不影响手动输入
        ensurePlaceholders() {
            if (this.placeholder.loaded || this.placeholder.loading) return;
            this.placeholder.loading = true;
            return request({
                url: '/serverManCmd/placeholders',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.placeholder.list = res.data || [];
                    this.placeholder.loaded = true;
                }
            }).finally(() => {
                this.placeholder.loading = false;
            });
        },
        // 记录最后聚焦的文本域：点击 chip 时文本框会失焦
        markActiveField(field) {
            this.placeholder.activeField = field;
        },
        insertPlaceholder(item) {
            const field = this.placeholder.activeField || 'contentTa';
            const refName = {
                contentTa: 'contentTaRef',
                contentTb: 'contentTbRef',
                contentTc: 'contentTcRef'
            }[field];
            const comp = this.$refs[refName];
            const textarea = comp && (comp.textarea || comp.$el.querySelector('textarea'));
            const token = item.token;
            const value = this.cmdForm.prop[field] || '';

            if (!textarea) {
                this.cmdForm.prop[field] = value + token;
                return;
            }

            const start = textarea.selectionStart === undefined ? value.length : textarea.selectionStart;
            const end = textarea.selectionEnd === undefined ? start : textarea.selectionEnd;
            this.cmdForm.prop[field] = value.slice(0, start) + token + value.slice(end);

            this.$nextTick(() => {
                textarea.focus();
                const pos = start + token.length;
                textarea.setSelectionRange(pos, pos);
            });
        },
        loadCmd(machineId) {
            const id = machineId || this.currentMachineId;
            this.cmdLoadingMap[id] = true;
            return request({
                url: '/serverManCmd/list',
                method: 'post',
                data: { token: this.$store.state.user.token, machineId: id }
            }).then(res => {
                if (res.code == 0) {
                    this.currentCmdMap[id] = res.meta.serverManCmds;
                }
            }).finally(() => {
                this.cmdLoadingMap[id] = false;
            });
        },
        saveCmd() {
            const prop = this.cmdForm.prop;
            const data = {
                machineId: prop.machineId,
                name: prop.name,
                description: prop.description,
                type: prop.type,
                contentTa: prop.contentTa,
                contentTb: prop.contentTb,
                contentTc: prop.contentTc,
                port: prop.port,
                interval: prop.interval
            };
            const isCreate = this.cmdForm.mode == 'create';
            this.savingCmd = true;
            return request({
                url: isCreate ? '/serverManCmd/create' : '/serverManCmd/edit',
                method: 'post',
                data: isCreate ? data : Object.assign({ id: prop.id }, data)
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({ message: '保存成功', type: 'success', duration: 2 * 1000 });
                    this.cmdForm.dialog = false;
                    this.loadCmd(prop.machineId || this.currentMachineId);
                }
            }).finally(() => {
                this.savingCmd = false;
            });
        },
        deleteCmd(row) {
            return request({
                url: '/serverManCmd/delete',
                method: 'post',
                data: { token: this.$store.state.user.token, id: row.id }
            }).then(res => {
                if (res.code == 0) {
                    this.loadCmd(row.machineId || this.currentMachineId);
                }
            });
        },
        runCmd(row) {
            return request({
                url: '/serverManCmd/run',
                method: 'post',
                data: { token: this.$store.state.user.token, id: row.id }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: res.msg,
                        type: 'success',
                        duration: 5 * 1000
                    });
                }
            });
        },
        exeLogDetail(row) {
            this.exeLogDialog.current.machine = row.machine;
            this.exeLogDialog.current.cmd = row.cmd;
            this.exeLogDialog.current.beginTime = row.beginTime;
            this.exeLogDialog.current.endTime = row.endTime;
            this.exeLogDialog.current.contentTa = row.contentTa;
            this.exeLogDialog.current.resolvedContentTa = row.resolvedContentTa || '';
            this.exeLogDialog.current.resultTa = row.resultTa;
            // 先清空上一次的输出，避免详情弹窗短暂展示旧内容
            this.exeLogDialog.current.fileDetail = '';
            this.exeLogDialog.dialog = true;
            this.logDetailLoading = true;
            return request({
                url: '/serverManExeLog/serverManOutput',
                method: 'post',
                data: { token: this.$store.state.user.token, dialogId: row.id, serialNumber: 1 }
            }).then(res => {
                if (res.code == 0) {
                    let output = '';
                    const list = res.data || [];
                    for (let i = 0; i < list.length; i++) {
                        output = output + list[i].output;
                    }
                    this.exeLogDialog.current.fileDetail = '```bash' + '\r\n' + output + '\r\n' + '```';
                }
            }).finally(() => {
                this.logDetailLoading = false;
            });
        },
        handleCopyCodeSuccess(code) {
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        },
        loadMyJoinTeam() {
            return request({
                url: '/team/getMyJoinTeams',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.team.myJoin = res.data || [];
                }
            });
        },
        // 服务器只存团队 id，按已加入团队列表还原团队名称
        resolveTeams(ids) {
            if (!Array.isArray(ids) || ids.length === 0) return [];
            const all = this.team.myJoin || [];
            return ids
                .map(id => all.find(t => String(t.id) === String(id)))
                .filter(Boolean);
        }
    }
};
</script>

<style scoped>
.server-page {
    /* 局部覆盖主色，与其它工作台页面保持同一套视觉语言 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --sm-text: #1f2d3d;
    --sm-sub: #5b6a80;
    --sm-muted: #aab4c4;
    --sm-line: #eef1f6;
    --sm-border: #e6eaf0;

    color: var(--sm-text);
}

/* ---------- 视图切换 ---------- */
.server-page :deep(.server-tabs .el-tabs__header) {
    margin: 0 0 14px;
}

.server-page :deep(.server-tabs .el-tabs__nav-wrap::after) {
    height: 0;
}

.server-page :deep(.server-tabs .el-tabs__active-bar) {
    display: none;
}

.server-page :deep(.server-tabs .el-tabs__item) {
    height: 34px;
    margin-right: 4px;
    padding: 0 16px;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 500;
    line-height: 34px;
    color: var(--sm-sub);
    transition: background-color 0.2s, color 0.2s;
}

.server-page :deep(.server-tabs .el-tabs__item:hover) {
    color: var(--sm-text);
    background-color: #f2f5fa;
}

.server-page :deep(.server-tabs .el-tabs__item.is-active) {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
}

/* tabs 内容区默认 overflow:hidden，会成为 sticky 的滚动容器导致吸顶失效，这里放开 */
.server-page :deep(.server-tabs .el-tabs__content) {
    overflow: visible;
}

/* ---------- 工具条 ---------- */
.sm-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: 10px;
    padding: 10px 16px;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    box-shadow: 0 10px 28px -22px rgba(31, 45, 61, 0.55);
}

.sm-toolbar__info {
    display: flex;
    align-items: center;
    min-width: 0;
}

.sm-toolbar__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 10px;
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    background: linear-gradient(135deg, #6a9cff 0%, #2f6fed 100%);
    box-shadow: 0 8px 16px -10px rgba(47, 111, 237, 0.9);
}

.sm-toolbar__meta {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.sm-toolbar__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--sm-text);
}

.sm-toolbar__subtitle {
    font-size: 12px;
    line-height: 16px;
    color: #a8abb2;
}

.sm-toolbar__actions {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

/* ---------- 按钮 ---------- */
.sm-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.sm-btn--ghost {
    color: #606266;
    background-color: #fff;
    border-color: #e4e7ed;
}

.sm-btn--ghost:hover,
.sm-btn--ghost:focus {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
    border-color: var(--el-color-primary-light-5);
    transform: translateY(-1px);
    box-shadow: 0 10px 18px -12px rgba(47, 111, 237, 0.9);
}

.sm-btn--sm {
    height: 30px;
    padding: 0 12px;
    font-size: 12px;
}

.sm-btn__icon {
    margin-right: 4px;
}

/* ---------- 面板容器 ---------- */
.sm-panel {
    margin-top: 12px;
    padding: 14px 16px;
    border: 1px solid var(--sm-border);
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}

.sm-panel :deep(.el-empty) {
    padding: 30px 0;
}

/* ---------- 服务器卡片（折叠面板） ---------- */
.server-page :deep(.machine-collapse) {
    border: 0;
}

.server-page :deep(.machine-collapse .el-collapse-item) {
    margin-bottom: 12px;
    border: 1px solid var(--sm-border);
    border-radius: 12px;
    background-color: #fff;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.server-page :deep(.machine-collapse .el-collapse-item:last-child) {
    margin-bottom: 0;
}

.server-page :deep(.machine-collapse .el-collapse-item:hover) {
    border-color: #d8e2f2;
}

.server-page :deep(.machine-collapse .el-collapse-item__header) {
    height: 54px;
    padding: 0 16px;
    border-bottom: 0;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
}

/* 允许标题区域收缩，避免长名称把展开箭头挤出容器 */
.server-page :deep(.machine-collapse .el-collapse-item__title) {
    min-width: 0;
    overflow: hidden;
}

.server-page :deep(.machine-collapse .el-collapse-item__header.is-active) {
    border-bottom: 1px solid var(--sm-line);
}

.server-page :deep(.machine-collapse .el-collapse-item__arrow) {
    color: var(--sm-muted);
}

.server-page :deep(.machine-collapse .el-collapse-item__wrap) {
    border-bottom: 0;
}

.server-page :deep(.machine-collapse .el-collapse-item__content) {
    padding: 14px 16px 16px;
}

/* ---------- 服务器分组 ---------- */
.machine-group + .machine-group {
    margin-top: 18px;
}

.machine-group__head {
    /* 分组标题悬浮吸顶：滚动时钉在顶部，滚到下一个分组时被顶走 */
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding: 8px 12px;
    border: 1px solid var(--el-color-primary-light-7);
    border-left: 3px solid var(--el-color-primary);
    border-radius: 8px;
    background: linear-gradient(90deg, var(--el-color-primary-light-8) 0%, var(--el-color-primary-light-9) 100%);
    box-shadow: 0 8px 16px -14px rgba(47, 111, 237, 0.9);
}

.machine-group__name {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.2px;
    color: var(--el-color-primary-dark-2);
}

.machine-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-width: 0;
}

.machine-head__main {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    overflow: hidden;
}

.machine-name {
    font-size: 14px;
    font-weight: 600;
    color: var(--sm-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.machine-address {
    font-size: 12px;
    color: var(--sm-muted);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.machine-lock {
    flex: none;
}

/* 指令条数标签：跟在地址后面，长名称时不被压缩 */
.machine-cmd-count {
    flex: none;
}

.machine-head__ops {
    display: flex;
    flex: none;
    align-items: center;
    gap: 14px;
    margin-right: 10px;
}

.machine-desc {
    margin: 0;
    font-size: 13px;
    line-height: 20px;
    color: var(--sm-sub);
}

/* ---------- 权限团队 ---------- */
.machine-teams {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    font-size: 12px;
}

.team-label {
    color: #8a94a6;
}

.team-tag {
    margin: 0;
}

.team-empty {
    color: var(--sm-muted);
}

/* ---------- 指令区块 ---------- */
.cmd-block {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px dashed var(--sm-line);
}

.cmd-block__head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.cmd-block__title {
    position: relative;
    padding-left: 10px;
    font-size: 13px;
    font-weight: 600;
    color: var(--sm-text);
}

.cmd-block__title::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 13px;
    margin-top: -6.5px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6a9cff, #3f6fff);
}

.cmd-block__head .sm-btn {
    margin-left: auto;
}

.count-pill {
    flex: none;
    padding: 1px 8px;
    border: 1px solid var(--el-color-primary-light-7);
    border-radius: 999px;
    background-color: #fff;
    color: var(--el-color-primary);
    font-size: 12px;
    line-height: 18px;
}

/* ---------- 表格 ---------- */
.sm-panel :deep(.sm-table) {
    --el-table-header-bg-color: #f7f9fc;
    font-size: 13px;
}

.sm-panel :deep(.sm-table th.el-table__cell) {
    color: var(--sm-muted);
    font-weight: 600;
}

.sm-panel :deep(.sm-table .el-table__cell) {
    padding: 9px 0;
}

.cmd-content {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 12px;
    color: var(--sm-sub);
}

/* ---------- 占位符面板 ---------- */
.ph-toggle {
    margin: -6px 0 14px 104px;
    font-size: 12px;
}

.ph-panel {
    margin: 0 0 18px;
    padding: 10px 12px;
    border: 1px dashed #d8e2f2;
    border-radius: 10px;
    background: #f8faff;
}

.ph-panel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.ph-panel__title {
    font-size: 13px;
    font-weight: 600;
    color: #1f2d3d;
}

.ph-panel__group {
    display: flex;
    gap: 8px;
    margin-top: 8px;
}

.ph-panel__group-name {
    flex: 0 0 58px;
    padding-top: 3px;
    font-size: 12px;
    color: #8a94a6;
}

.ph-panel__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-height: 72px;
    overflow-y: auto;
}

.ph-chip {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    cursor: pointer;
}

.ph-chip:hover {
    color: var(--el-color-primary);
    border-color: var(--el-color-primary-light-5);
    background: var(--el-color-primary-light-9);
}

.ph-panel__tip {
    margin: 8px 0 0;
    font-size: 12px;
    line-height: 16px;
    color: #aab4c4;
}

/* ---------- 行内操作 ---------- */
.sm-op {
    margin-right: 14px;
    font-size: 13px;
}

.sm-op:last-child {
    margin-right: 0;
}

/* ---------- 执行日志 ---------- */
.log-search {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px dashed var(--sm-line);
}

.log-search__fields {
    display: grid;
    flex: 1 1 520px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
}

.log-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.log-field__label {
    font-size: 12px;
    line-height: 16px;
    color: #8a94a6;
}

.log-search__actions {
    display: flex;
    flex: none;
    gap: 10px;
}

.exe-log-time {
    display: flex;
    flex-direction: column;
    line-height: 1.5;
}

.exe-log-time__begin {
    color: var(--sm-text);
}

.exe-log-time__end {
    font-size: 12px;
    color: var(--sm-muted);
}

.exe-log-address {
    color: #909399;
    font-size: 12px;
}

/* ---------- 分页（悬浮圆角胶囊） ---------- */
.exe-log-pagination {
    display: flex;
    align-items: center;
    gap: 12px;
    width: fit-content;
    max-width: 100%;
    margin: 16px auto 0;
    padding: 7px 18px;
    border: 1px solid var(--sm-border);
    border-radius: 999px;
    background-color: #fff;
    box-shadow: 0 12px 30px -14px rgba(28, 47, 84, 0.22);
}

.exe-log-pagination__total {
    font-size: 12px;
    line-height: 18px;
    color: #8a94a6;
    white-space: nowrap;
}

.exe-log-pagination :deep(.el-pagination) {
    /* 分页按钮原本是 2px 直角，这里统一成圆角胶囊 */
    --el-pagination-border-radius: 9px;
    --el-pagination-font-size: 13px;
    --el-pagination-button-width: 30px;
    --el-pagination-button-height: 30px;
    --el-pagination-item-gap: 8px;
}

.exe-log-pagination :deep(.el-pager li.is-active) {
    box-shadow: 0 6px 14px -10px rgba(47, 111, 237, 0.95);
}

.exe-log-pagination :deep(.el-pager li:not(.is-active):hover),
.exe-log-pagination :deep(.el-pagination button:hover:not(:disabled)) {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    .sm-toolbar {
        padding: 10px 12px;
    }

    .sm-toolbar__subtitle {
        display: none;
    }

    .sm-toolbar__actions {
        flex: 1 1 100%;
    }

    .sm-toolbar__actions .sm-btn {
        flex: 1 1 0;
    }

    .sm-panel {
        padding: 12px;
    }

    .machine-head__ops {
        margin-right: 4px;
    }

    .log-search__actions {
        flex: 1 1 100%;
    }

    .log-search__actions .sm-btn {
        flex: 1 1 0;
    }

    /* 窄屏下收起总数文案，让胶囊分页更紧凑 */
    .exe-log-pagination {
        gap: 6px;
        margin-top: 12px;
        padding: 6px 14px;
    }

    .exe-log-pagination__total {
        display: none;
    }
}
</style>

<!-- 弹窗会 teleport 到 body，样式需放在非 scoped 块并带唯一前缀 -->
<style>
.sm-dialog {
    /* 主色令牌需在此再声明一遍，弹窗取不到页面作用域 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    max-width: calc(100vw - 32px);
    border-radius: 14px;
    box-shadow: 0 18px 50px -12px rgba(28, 47, 84, 0.22);
}

.sm-dialog--full {
    max-width: 100vw;
    border-radius: 0;
}

.sm-dialog .el-dialog__header {
    margin-right: 0;
    padding: 22px 24px 0;
}

.sm-dialog .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: #1f2d3d;
}

.sm-dialog .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
}

.sm-dialog .el-dialog__body {
    padding: 18px 24px 4px;
}

.sm-dialog .el-dialog__footer {
    padding: 0 24px 22px;
}

.sm-dialog .el-form-item {
    margin-bottom: 18px;
}

.sm-dialog .el-form-item__label {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: #8a94a6;
}

.sm-dialog .sm-switch-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.sm-dialog .sm-tips {
    margin: 6px 0 0;
    font-size: 12px;
    line-height: 16px;
    color: #aab4c4;
}

.sm-dialog .sm-switch-row .sm-tips {
    margin: 0;
}

.sm-dialog .sm-mono textarea {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 12px;
    line-height: 18px;
}

.sm-dialog__foot {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.sm-dialog__foot .el-button {
    min-width: 96px;
    height: 38px;
    margin-left: 0;
    border-radius: 10px;
}

.sm-dialog__foot--center {
    justify-content: center;
}

.sm-dialog__foot--center .el-button {
    min-width: 220px;
}

/* ---------- 全屏详情：内容区滚动，底部按钮固定可见 ---------- */
.sm-dialog--full.is-fullscreen {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.sm-dialog--full.is-fullscreen .el-dialog__header {
    flex: none;
}

.sm-dialog--full.is-fullscreen .el-dialog__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 14px 16px 16px;
}

.sm-dialog--full.is-fullscreen .el-dialog__footer {
    flex: none;
    padding: 12px 24px 16px;
    border-top: 1px solid #eef1f6;
    background-color: #fff;
}

/* ---------- 日志详情 ---------- */
.sm-dialog .log-detail {
    min-height: 200px;
}

.sm-dialog .log-detail__block {
    border: 1px solid #e6eaf0;
    border-radius: 12px;
    margin-bottom: 14px;
    padding: 14px 16px;
    background-color: #fff;
}

.sm-dialog .log-detail__title {
    position: relative;
    margin-bottom: 12px;
    padding-left: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #1f2d3d;
}

.sm-dialog .log-detail__title::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 13px;
    margin-top: -6.5px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6a9cff, #3f6fff);
}

.sm-dialog .log-detail__editor {
    min-height: 120px;
}

/* 主题默认给 markdown 内容加了 2rem 2.5rem 的内边距，这里去掉以铺满命令行区域 */
.sm-dialog .log-detail__editor .vuepress-markdown-body {
    padding: 0;
}

/* 代码块自带左右 -1.5rem 负外边距（用于抵扣主题的 2.5rem 内边距），
   内边距清零后必须一并归零，否则代码块两侧溢出，行号列与复制按钮会被裁切 */
.sm-dialog .log-detail__editor .vuepress-markdown-body div[class*=v-md-pre-wrapper-] {
    margin-left: 0;
    margin-right: 0;
}

.sm-dialog .exe-log-script {
    white-space: pre-wrap;
    word-break: break-all;
}

.sm-dialog .log-time-sep {
    margin: 0 8px;
    color: #c0c4cc;
}

.sm-dialog .log-time-end {
    color: #8a94a6;
}

@media (max-width: 768px) {
    .sm-dialog .el-dialog__header {
        padding: 16px 16px 0;
    }

    .sm-dialog .el-dialog__body {
        padding: 14px 14px 4px;
    }

    .sm-dialog .el-dialog__footer {
        padding: 0 14px 16px;
    }

    .sm-dialog .log-detail__block {
        padding: 12px;
    }

    .sm-dialog__foot .el-button {
        flex: 1 1 0;
    }
}
</style>
